$(document).ready(function(){
  $("#product-add-to-cart").click(function(e){
    e.preventDefault();
   
    var got = 'true';
    if($('label.custom-size').hasClass('custom-selected')){
    
      if ($("#bust").val() == "" ) {
        $("#bust").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#bust").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#waist").val() == ""){
        $("#waist").css('border', "1.5px solid red");
        var got = 'false'
      } 
      else{
        $("#waist").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#hips").val() == "") {
        $("#hips").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#hips").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#hollow").val() == "") {
        $("#hollow").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#hollow").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#hollow2").val() == "") {
        $("#hollow2").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#hollow2").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#length").val() == "") {
        $("#length").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#length").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#confirma").is(':checked')) {
        $(".confirm").css('border', "1.5px solid #f1f1f1");
      }  
      else{
        $(".confirm").css('border', "1.5px solid red");
      }
    }
    
   if(got == 'true'){
      $('#AddToCartText-Template_Design_one').hide();
      $('.loader_Add_Cat').removeClass('hide');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:$(".shopify-product-form").serialize(),
        dataType: 'json',
        success: function(response){
          jQuery.getJSON('/cart.js', function(cart) {
            console.log(cart);
            //alert('There are now ' + cart.item_count + ' items in the cart.');
            
            var price = cart.total_price/100;
            let items = cart.items;
            var prodct_has_cart = [];
            for(var i=0; i < items.length; i++){
              var item_id = items[i].id;
              if(item_id ==  40259217293410){
                prodct_has_cart.push(1);
              }
            }
            if (price > 999999999){
              if(prodct_has_cart[0] != 1){
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: '&id=40259217293410', 
                  dataType: 'json',
                  success:function(response) {
                    window.location.href = '/cart';
                  }
                });
              }
              else{
                window.location.href = '/cart';
              }  
            }
            else{
              jQuery.post('/cart/update.js', 'updates[40259217293410]=0');
                window.location.href = '/cart';
            }
         });
        },
        error: function(resp) {
          var getres = JSON.stringify(resp);
          alert(resp.responseJSON.description);
        }
      });
   }
  });
});
